export function toDisplayName(s: string): string {
  const parts = s.trim().split(/[\s.]+/).filter(Boolean);
  return parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()).join(" ");
}
